import Rete, { Socket} from "rete";
import VueComparisonControl from "./ComparisonControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class ComparisonControl extends Rete.Control {
  constructor(emitter, key) {
    super(key);
    this.render = "vue";
    this.component = VueComparisonControl;
    this.props = { emitter, ikey: key };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const ComparisonSocket = new Socket("Comparison");
ComparisonSocket.combineWith(AnyTypeSocket);
export { ComparisonSocket };
